<template>
    <div>
        <app-bar :actionBtns="{ visible: isImportSuccess ? true : false }" :backBtn="{ visible: true }">
            <template #title>Add Branch</template>
            <template v-slot:actionBtns v-if="isImportSuccess">
                <v-btn color="black" class="mx-1" outlined text @click="reset = true">Import Another File</v-btn>
            </template>
        </app-bar>
        <ImportForm classification="BRANCH" :isImportSuccess="isImportSuccess" :reset="reset" />
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import ImportForm from '@/components/Merchant/ImportForm.vue';

export default {
    name: 'AddImport',
    components: {
        AppBar,
        ImportForm
    },
    data() {
        return {
            reset: false
        };
    },
    computed: {
        isImportSuccess() {
            return this.$store.getters['merchants/getIsImportSuccess'];
        }
    }
};
</script>
